import { toast } from "@/app/_utils/toast";

import type { Issue } from "../checklistValidation";

const MAX_LISTED = 8;

export function showValidationToast(issues: Issue[], onSelect: (issue: Issue) => void) {
  const count = issues.length;
  toast.error(`${count} ${count === 1 ? "problem" : "problems"} to fix before saving`, {
    duration: 15000,
    description: (
      <ul className="m-0 mt-1 flex list-none flex-col gap-0.5 p-0">
        {issues.slice(0, MAX_LISTED).map((issue, i) => (
          <li key={i}>
            <button
              type="button"
              onClick={() => onSelect(issue)}
              className="w-full rounded px-1 py-0.5 text-left text-[12.5px] hover:bg-black/5"
            >
              <span className="font-medium underline-offset-2 hover:underline">{issue.where}</span>
              <span className="opacity-80">: {issue.message}</span>
            </button>
          </li>
        ))}
        {count > MAX_LISTED && (
          <li className="px-1 text-[12px] opacity-70">and {count - MAX_LISTED} more</li>
        )}
      </ul>
    ),
  });
}
